<template>
<div class="content-list">
  <div>
     <h1 style="text-align: center;">{{msg}}</h1>
     <div style="width:100%;height:100%;text-align:center;margin-top:60px;">
       <img style="text-align:center;" src="../../../static/image/homeBg.png" alt="">
     </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      msg: "欢迎使用荣耀轻量化平台作业中心"
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/home/home.vue